export default "__VITE_PUBLIC_ASSET__ec32e959__"